<template>
  <van-field
    type="number"
    v-model="smscode"
    center
    label="验证码"
    placeholder="请输入短信验证码"
    maxlength="4"
  >
    <template #button>
      <van-button v-if="!cutDownTime" size="small" type="primary" @click="sendSMSCode">发送验证码</van-button>
      <van-button v-if="cutDownTime" size="small" type="primary">{{ countdown }}s后再试</van-button>
    </template>
  </van-field>
</template>


<script>
import { Toast } from "vant";

let timer;
export default {
  name: "captcha",
  props: {
    code: String,
    phone: String
  },
  data() {
    return {
      busType: 0,
      cutDownTime: false,
      countdown: 60,
      captchaChecked: "0",
      isSendCode: 0,
      smscode: "",
      isTrue: true
    };
  },
  watch: {
    smscode(newVal) {
      this.$emit("update:code", newVal);
      this.checkCaptchaInput();
    }
  },
  methods: {
    sendSMSCode() {
      if (this.phone == "") {
        Toast("请填写手机号！");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast("手机号码格式输入错误");
        return;
      }
      if (!this.cutDownTime) {
        timer = setInterval(() => {
          this.countDown();
        }, 1000);
        this.refreshCaptcha();
      }
    },
    countDown() {
      if (this.countdown <= 0) {
        window.clearInterval(timer);
        this.cutDownTime = false;
        this.countdown = 60;
      } else {
        // eslint-disable-next-line no-plusplus
        this.countdown = this.countdown - 1;
        this.cutDownTime = true;
      }
    },
    refreshCaptcha() {
      this.$store.dispatch("captcha/generateCaptcha", { phone: this.phone, busType: this.busType }).then(() => {
        this.isSendCode = 1;
      });
    },
    checkCaptchaInput() {
      if (this.smscode.length !== 4 || this.isSendCode == 0) {
        this.captchaChecked = "0";
        return;
      }
      this.$store.dispatch("captcha/checkCaptcha", {
        phone: this.phone,
        busType: this.busType,
        codeNum: this.smscode
      }).then((res) => {
        if (res.code === 1) {
          this.captchaChecked = "1";
        } else if (res.code === -1) {
          this.captchaChecked = "0";
          Toast("验证码错误");
        } else if (res.code === -2) {
          this.captchaChecked = "0";
          Toast("验证码已失效");
        } else {
          this.captchaChecked = "0";
          Toast("验证码错误");
        }
      });
    },
    submitCaptcha() {
      if (this.smscode === null || this.smscode === "") {
        Toast("验证码错误");
        return;
      }
      this.$store.dispatch("captcha/submitCaptcha", {
        phone: this.phone,
        busType: this.busType,
        codeNum: this.smscode
      }).then((res) => {
        if (res.code === 1) {
          this.isTrue = 1;
        } else {
          Toast(res.msg);
          this.isTrue = 0;
        }
        // this.$emit("update:isSmsTrue", this.isTrue);
      });
    },
    delCaptcha() {
      this.$store.dispatch("captcha/delCaptcha", { phone: this.phone, busType: this.busType }).then(() => {
      });
    }
  }
};
</script>

<style scoped>
.van-button--primary {
  color: #fff;
  background-color: #ff0023;
  border: 0.01333rem solid #ff0023;
}

button:active, a:active {
  background-color: #ff0023 !important;
}
/deep/.van-field__label {
  width: 55px;
}
</style>
